import { Cookies } from 'react-cookie';

import { generateAnonymousUserId } from '@utils/index';

export const ANONYMOUS_USER_ID_KEY = 'anonymous_user_id';
export const TOKEN_COOKIE_KEY = 'auth_token';

const cookies = new Cookies();

const COOKIE_MAX_AGE = 365 * 24 * 60 * 60; // 1 year
const AUTH_TOKEN_MAX_AGE = 7 * 24 * 60 * 60; // 7 days for auth tokens

const COOKIE_OPTIONS = {
  path: '/',
  maxAge: COOKIE_MAX_AGE,
  secure: process.env.NODE_ENV === 'production',
  sameSite: 'strict' as const,
};

const AUTH_TOKEN_OPTIONS = {
  path: '/',
  maxAge: AUTH_TOKEN_MAX_AGE,
  secure: process.env.NODE_ENV === 'production',
  sameSite: 'strict' as const,
  httpOnly: false,
};

export const cookieService = {
  setAuthToken: (token: string) =>
    cookies.set(TOKEN_COOKIE_KEY, token, AUTH_TOKEN_OPTIONS),

  removeAuthToken: () => cookies.remove(TOKEN_COOKIE_KEY, { path: '/' }),

  getAuthToken: (): string | undefined => cookies.get(TOKEN_COOKIE_KEY),

  setAnonymousUserId: (id?: string): string => {
    const anonymousId = id || generateAnonymousUserId();
    cookies.set(ANONYMOUS_USER_ID_KEY, anonymousId, COOKIE_OPTIONS);
    return anonymousId;
  },

  removeAnonymousUserId: () =>
    cookies.remove(ANONYMOUS_USER_ID_KEY, { path: '/' }),

  getAnonymousUserId: (): string | undefined =>
    cookies.get(ANONYMOUS_USER_ID_KEY),

  ensureAnonymousUserId: (id?: string): string => {
    const existingId = cookies.get(ANONYMOUS_USER_ID_KEY);

    if (id === undefined) {
      return existingId || cookieService.setAnonymousUserId();
    }

    if (!existingId || existingId !== id) {
      return cookieService.setAnonymousUserId(id);
    }

    return existingId;
  },
};
